import React from 'react';

// Importing icons to match the card style
import ListAltIcon from '@material-ui/icons/ListAlt';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

// --- Data Constants ---

const SUMMARY_METRICS = [
    { label: 'Open Actions', value: '48', delta: 'cross-functional', tone: 'blue', icon: <ListAltIcon />, deltaTone: 'blue' },
    { label: 'On Track', value: '72%', delta: '+8 pp', tone: 'green', icon: <CheckCircleIcon />, deltaTone: 'good' },
    { label: 'At Risk', value: '9', delta: 'need escalation', tone: 'purple', icon: <WarningIcon />, deltaTone: 'bad' },
    { label: 'Value Tracked', value: '₹82 Cr', delta: 'across actions', tone: 'orange', icon: <AttachMoneyIcon />, deltaTone: 'good' },
];

const ACTION_PORTFOLIO_DATA = [
    { action: 'Shift 60k cases South → North', source: 'Capacity', owner: 'Operations', due: '24h', expected: '₹12 Cr', status: 'On Track' },
    { action: 'Redeploy East → Maharashtra', source: 'Demand', owner: 'Supply', due: '72h', expected: '₹9 Cr', status: 'In Progress' },
    { action: 'Advance 750ml glass PO', source: 'Packaging', owner: 'Procurement', due: '48h', expected: '₹7 Cr', status: 'At Risk' },
    { action: 'Reduce Core D production', source: 'Demand', owner: 'Planning', due: 'This week', expected: '₹5 Cr', status: 'Open' },
    { action: 'Prioritize Premium F', source: 'Mix', owner: 'S&OP', due: '48h', expected: '₹6 Cr', status: 'On Track' },
];

const REALIZED_VALUE_DATA = [
    { label: 'Revenue', percentage: 82, color: '#22c55e' },   // Green
    { label: 'Service', percentage: 70, color: '#3b82f6' },   // Blue
    { label: 'Inventory', percentage: 55, color: '#22c55e' }, // Green
    { label: 'Margin', percentage: 48, color: '#22c55e' },    // Green
    { label: 'Cash', percentage: 62, color: '#22c55e' },      // Green
];

export class Initiatives extends React.Component {
    render() {
        return (
            <div className="cc-page">
                {/* Header */}
                <div className="cc-header">
                    <div className="cc-header-text">
                        <h1>Initiatives & Action Centre</h1>
                        <p>Turn optimizer recommendations into owned actions and measure whether the expected value was realized.</p>
                    </div>
                    <div className="cc-header-filters">
                        <button className="cc-filter-btn">Next 8 Weeks</button>
                        <button className="cc-filter-btn">All States</button>
                        <button className="cc-filter-btn">All Brands</button>
                    </div>
                </div>

                {/* Top Metrics Row - Updated to match the card style */}
                <div className="cc-metric-row">
                    {SUMMARY_METRICS.map((metric) => (
                        <div className={`cc-metric-card tone-${metric.tone}`} key={metric.label}>
                            <div className="cc-metric-icon-wrap">{metric.icon}</div>
                            <div className="cc-metric-content">
                                <div className="cc-metric-label">{metric.label}</div>
                                <div className="cc-metric-value">{metric.value}</div>
                                <div className={`cc-metric-delta cc-delta-${metric.deltaTone}`}>
                                    {metric.delta}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Content Row */}
                <div className="cc-main-row">
                    {/* Left Panel: Cross-Functional Action Portfolio */}
                    <div className="cc-panel cc-panel-table cc-panel-dashed">
                        <h2>Cross-Functional Action Portfolio</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>Action</th>
                                    <th>Source</th>
                                    <th>Owner</th>
                                    <th>Due</th>
                                    <th>Expected ₹</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ACTION_PORTFOLIO_DATA.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.action}</td>
                                        <td>{row.source}</td>
                                        <td>{row.owner}</td>
                                        <td>{row.due}</td>
                                        <td>{row.expected}</td>
                                        <td className={
                                            row.status === 'On Track' ? 'cc-delta-good' : 
                                            row.status === 'At Risk' ? 'cc-delta-bad' : 
                                            row.status === 'In Progress' ? 'cc-delta-warn' : ''
                                        }>
                                            {row.status}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Right Panel: Owner / Due Date / Realized Value */}
                    <div className="cc-panel">
                        <h2>Owner / Due Date / Realized Value</h2>
                        
                        {/* Horizontal Bar Charts */}
                        <div className="cc-bar-chart-container" style={{marginTop: '20px'}}>
                            {REALIZED_VALUE_DATA.map((bar) => (
                                <div className="cc-bar-row" key={bar.label}>
                                    <div className="cc-bar-label">{bar.label}</div>
                                    <div className="cc-bar-track">
                                        <div 
                                            className="cc-bar-fill" 
                                            style={{ width: `${bar.percentage}%`, backgroundColor: bar.color }}
                                        ></div>
                                    </div>
                                    <div className="cc-bar-percent" style={{ color: bar.color }}>
                                        {bar.percentage}%
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Footer Text */}
                        <div className="cc-measure-text">
                            <p>Measure expected → actioned → realized value, not just task completion.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Initiatives;